

































































































































































import Vue from "vue";
import moment from "moment";
import axios, { AxiosPromise } from "axios";
import Multiselect from "vue-multiselect";
import DateRangePicker from "../../components/DateRangePicker.vue";
import ButtonAction from "../../components/ButtonAction.vue";
import {
  DropdownItemStringViewModel,
  DropdownItemModel,
  FixedPeriodType,
  FilterValuesPeriod
} from "../../TypeScriptModels";
import debounce from "lodash-es/debounce";
import get from "lodash-es/get";
import find from "lodash-es/find";
import orderBy from "lodash-es/orderBy";
import isEmpty from "lodash-es/isEmpty";
import { Autorisatie } from "../../Autorisatie";
import { ApplicationActions } from "../../store";
import { Dispatcher, Committer } from "vuex-type-helper";
import { saveAs } from "file-saver";
import TransitionExpand from "@/components/TransitionExpand.vue";

interface RapportageSettingsViewModel {
  CustomStartDate: string | null;
  CustomEndDate: string | null;
  SelectedPeriod: FixedPeriodType;
  SelectedVestigingen: string[];
  SelectedModellen: string[];
  SelectedReportType: number;
  SelectedLeadTypes: number[];
  SelectedReportTijdSelectieType: number;
}

interface ReportQueryViewModel {
  ReportType: ReportType;
  Language: Language;
  FromDate: string;
  ToDate: string;

  Vestigingen: string[];
  Modellen: string[];
  ReportTijdSelectieType: ReportTijdSelectieType;

  LeadTypen: number[];
}

enum ReportType {
  Leads = 1,
  Orders = 2,
  Dealerleads = 3
}

enum LeadType {
  Sales = 1,
  Aftersales = 2
}

enum Language {
  Nederlands = 1,
  English = 2
}

enum ReportTijdSelectieType{
  DatumAfgerond = 1,
  DatumAangemaakt = 2,
}

export default Vue.extend({
  components: {
    Multiselect,
    DateRangePicker,
    ButtonAction,
    TransitionExpand
},
  data() {
    return {
      initialised: false,
      generatingReport: false,
      timerRenewToken: 0,
      reportID: "",
      downloadUrl: "",
      selectedOptions: {
        period: {} as null | any,

        reportTypeValue: null as any,
        reportTijdSelectieTypeValue: null as any,

        leadTypesValue: [] as any[],
        vestigingenValue: [] as any[],
        modellenValue: [] as any[],

        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date()
      },
      options: {
        Reports: [] as DropdownItemModel[],
        LeadTypes: [] as DropdownItemModel[],
        ReportTijdSelectieTypes: [] as DropdownItemModel[],
        Perioden: [] as DropdownItemModel[],
        Modellen: [] as DropdownItemStringViewModel[],
        Vestigingen: [] as DropdownItemStringViewModel[]
      },  
      handlePreferenceChangedDebounced: null as null | Function,
      destroyed: false,
      waitConnect: 2500,

      websocket: null as null | WebSocket
    };
  },
  created() {
    this.selectedOptions.period = {
      Id: FixedPeriodType.ThisYear,
      Omschrijving: `${this.$i18n.t("timefilters.thisyear")}`
    };
    this.options.LeadTypes = [
      { Id: LeadType.Sales, Omschrijving: `${this.$i18n.t("leadtypesales")}` },
      {
        Id: LeadType.Aftersales,
        Omschrijving: `${this.$i18n.t("leadtypeaftersales")}`
      }
    ];
    this.options.Reports = [
      { Id: ReportType.Leads, Omschrijving: `${this.$i18n.t("leads")}` },
      { Id: ReportType.Orders, Omschrijving: `${this.$i18n.t("orders")}` },
      { Id: ReportType.Dealerleads, Omschrijving: `${this.$i18n.t("dealerleads")}` },
    ];
    this.options.ReportTijdSelectieTypes = [
      {Id: ReportTijdSelectieType.DatumAfgerond, Omschrijving: `${this.$i18n.t("datumafgerond")}`},
      {Id: ReportTijdSelectieType.DatumAangemaakt, Omschrijving: `${this.$i18n.t("datumaangemaakt")}`}
    ];
    
    if (this.hasAutorisatieLeads) {
      this.selectedOptions.reportTypeValue = this.options.Reports.filter(
        item => item.Id === ReportType.Leads
      )[0];
      this.selectedOptions.reportTijdSelectieTypeValue = this.options.ReportTijdSelectieTypes.filter(
        item => item.Id == ReportTijdSelectieType.DatumAfgerond
      )[0];
    } else if (this.hasAutorisatieOrders) {
      this.selectedOptions.reportTypeValue = this.options.Reports.filter(
        item => item.Id === ReportType.Orders
      )[0];
    } else if (this.hasAutorisatieDealerleads) {
      this.selectedOptions.reportTypeValue = this.options.Reports.filter(
        item => item.Id === ReportType.Dealerleads
      )[0];
      this.selectedOptions.reportTijdSelectieTypeValue = this.options.ReportTijdSelectieTypes.filter(
        item => item.Id == ReportTijdSelectieType.DatumAfgerond
      )[0];
    }
  },
  mounted() {
    this.connect();
    this.destroyed = false;
  },
  watch: {
    locale(newValue) {
      if (!!newValue) {
        this.updateLeadTypes();
        this.updateReportTypes();
        this.updateReportTijdSelectieTypes();
      }
    }
  },
  computed: {
    showGenerateButton(): boolean {
      if (!this.initialised) return false;

      return !this.generatingReport;
    },
    showLoading(): boolean {
      if (!this.initialised) return false;

      return this.generatingReport;
    },
    locale(): string | null {
      return this.$store.getters.locale;
    },
    modellenOptions(): null | any[] {
      return orderBy(
        get(this.options, "Modellen", []),
        ["Omschrijving"],
        ["asc"]
      );
    },
    vestigingenOptions(): null | any[] {
      return orderBy(
        get(this.options, "Vestigingen", []),
        ["Omschrijving"],
        ["asc"]
      );
    },
    leadtypeOptions(): null | any[] {
      return orderBy(
        get(this.options, "LeadTypes", []),
        ["Omschrijving"],
        ["asc"]
      );
    },
    reportTijdSelectieTypeOptions(): null | any[] {
      return orderBy(
        get(this.options, "ReportTijdSelectieTypes", []),
        ["Omschrijving"],
        ["asc"]
      );
    },
    showOrderOptions(): boolean {
      return (
        this.initialised &&
        !isEmpty(this.selectedOptions.reportTypeValue) &&
        this.selectedOptions.reportTypeValue.Id === ReportType.Orders
      );
    },
    showLeadsOptions(): boolean {
      return (
        this.initialised &&
        !isEmpty(this.selectedOptions.reportTypeValue) &&
        this.selectedOptions.reportTypeValue.Id === ReportType.Leads
      );
    },
    showDealerleadsOptions(): boolean {
      return (
        this.initialised &&
        !isEmpty(this.selectedOptions.reportTypeValue) &&
        this.selectedOptions.reportTypeValue.Id === ReportType.Dealerleads
      );
    },
    reportTypesOptions(): null | any[] {
      let opties = [...get(this.options, "Reports", [])];

      if (!this.hasAutorisatieLeads) {
        opties = opties.filter(item => item.Id !== ReportType.Leads);
      }
      if (!this.hasAutorisatieOrders) {
        opties = opties.filter(item => item.Id !== ReportType.Orders);
      }
      if (!this.hasAutorisatieDealerleads) {
        opties = opties.filter(item => item.Id !== ReportType.Dealerleads);
      }

      return orderBy(opties, ["Omschrijving"], ["asc"]);
    },
    hasAutorisatieLeads(): boolean {
      return this.$store.getters.hasAutorisatie(Autorisatie.RapportageLeads);
    },
    hasAutorisatieOrders(): boolean {
      return this.$store.getters.hasAutorisatie(Autorisatie.RapportageOrders);
    },
    hasAutorisatieDealerleads(): boolean {
      return this.$store.getters.hasAutorisatie(Autorisatie.RapportageDealerleads);
    },
    reportTijdAfgerondSelected(): boolean {
      console.log(this.selectedOptions.reportTijdSelectieTypeValue)
      return this.selectedOptions.reportTijdSelectieTypeValue.Id == ReportTijdSelectieType.DatumAfgerond
    },
  },
  methods: {
    handleDateoptionsChanged(perioden: { Id: number; Omschrijving: string }[]) {
      this.options.Perioden = perioden;
    },
    onDateRangePickerMounted(perioden: { Id: number; Omschrijving: string }[]) {
      this.handleDateoptionsChanged(perioden);
      this.fillFilters();
    },
    handlePreferencesChanged: function() {
      if (!this.handlePreferenceChangedDebounced) {
        this.handlePreferenceChangedDebounced = debounce(() => {
          this.persistPreferences();
        }, 300);
      }
      this.handlePreferenceChangedDebounced();
    },
    fillFilters() {
      //opties van het orderdashboard ophalen:
      axios
        .get("/api/backend/v1/dashboard/orders/options")
        .then(response => {
          if (!!response && !!response.data) {
            let { Vestigingen, Modellen } = response.data;

            this.options.Vestigingen = Vestigingen;
            this.options.Modellen = Modellen;

            this.getSavesPreferences();
          }
        })
        .catch(error => {});
    },
    getSavesPreferences() {
      axios
        .get("/api/backend/v1/identity/preferences/reports")
        .then(response => {
          if (!!response && !!response.data && !!response.data.FilterSettings) {
            const filtersettings = response.data
              .FilterSettings as RapportageSettingsViewModel;

            this.selectedOptions.vestigingenValue = (get(
              this.options,
              "Vestigingen",
              []
            ) as any[]).filter(
              a => filtersettings.SelectedVestigingen.indexOf(a.Id) > -1
            );

            this.selectedOptions.modellenValue = (get(
              this.options,
              "Modellen",
              []
            ) as any[]).filter(
              a => filtersettings.SelectedModellen.indexOf(a.Id) > -1
            );

            if (
              (this.hasAutorisatieLeads || this.hasAutorisatieDealerleads) &&
              !isEmpty(filtersettings.SelectedLeadTypes)
            ) {
              this.selectedOptions.leadTypesValue = (get(
                this.options,
                "LeadTypes",
                []
              ) as any[]).filter(
                a => filtersettings.SelectedLeadTypes.indexOf(a.Id) > -1
              );
            }

            if (!!filtersettings.SelectedReportType) {
              let allowedOption = (this.reportTypesOptions as any[]).filter(
                item => item.Id === filtersettings.SelectedReportType
              );
              if (allowedOption.length > 0)
                this.selectedOptions.reportTypeValue = allowedOption[0];
            }

            let selectOn = (this.reportTijdSelectieTypeOptions as any[]).filter(
              item => item.Id === filtersettings.SelectedReportTijdSelectieType
              );
              
            if( selectOn.length == 0 || selectOn == null){
              this.selectedOptions.reportTijdSelectieTypeValue = (this.reportTijdSelectieTypeOptions as any[]).filter(
                item => item.Id === ReportTijdSelectieType.DatumAfgerond
              )[0]
            }
            else{
              this.selectedOptions.reportTijdSelectieTypeValue = selectOn[0];
            }

            let period = find(
              get(this.options, "Perioden", []),
              p => p.Id === filtersettings.SelectedPeriod
            );

            if (!!period) {
              this.selectedOptions.period = period;
            }

            this.selectedOptions.customFromDate = moment(
              filtersettings.CustomStartDate as string
            ).local().startOf("day").toDate();

            this.selectedOptions.customToDate = moment(
              filtersettings.CustomEndDate as string
            ).local().endOf("day").toDate();
          } //preferences set
          this.initialised = true;
          this.$emit("initialised", true);
        })
        .catch(error => {});
    },
    persistPreferences() {
      if (!this.initialised) return;

      let settings = {
        CustomStartDate: (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString(),
        CustomEndDate: (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString(),		
        SelectedPeriod: get(
          this.selectedOptions,
          "period.Id",
          FixedPeriodType.ThisYear
        ),

        SelectedVestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => String(elem["Id"])),

        SelectedModellen: get(
          this.selectedOptions as Object,
          "modellenValue",
          []
        ).map((elem: any) => String(elem["Id"])),

        SelectedLeadTypes: get(
          this.selectedOptions as Object,
          "leadTypesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),

        SelectedReportType: this.selectedOptions.reportTypeValue.Id,
        SelectedReportTijdSelectieType: this.selectedOptions.reportTijdSelectieTypeValue.Id
      } as RapportageSettingsViewModel;
      axios.post("/api/backend/v1/identity/preferences/reports", settings, {
        headers: { "Content-Type": "application/json" }
      });
    },
    updateLeadTypes() {
      this.options.LeadTypes.forEach(
        (item: { Id: any; Omschrijving: string }) => {
          switch (item.Id) {
            case LeadType.Sales:
              item.Omschrijving = `${this.$i18n.t("leadtypesales")}`;
              break;
            case LeadType.Aftersales:
              item.Omschrijving = `${this.$i18n.t("leadtypeaftersales")}`;
              break;
            default:
              break;
          }
        }
      );
    },
    updateReportTypes() {
      this.options.Reports.forEach(
        (item: { Id: any; Omschrijving: string }) => {
          switch (item.Id) {
            case ReportType.Leads:
              item.Omschrijving = `${this.$i18n.t("leads")}`;
              break;
            case ReportType.Orders:
              item.Omschrijving = `${this.$i18n.t("orders")}`;
              break;
            case ReportType.Dealerleads:
              item.Omschrijving = `${this.$i18n.t("dealerleads")}`;
              break;
            default:
              break;
          }
        }
      );
    },
    updateReportTijdSelectieTypes() {
      this.options.ReportTijdSelectieTypes.forEach(
        (item: { Id: any; Omschrijving: string }) => {
          switch (item.Id) {
            case ReportTijdSelectieType.DatumAangemaakt:
              item.Omschrijving = `${this.$i18n.t("datumaangemaakt")}`;
              break;
            case ReportTijdSelectieType.DatumAfgerond:
              item.Omschrijving = `${this.$i18n.t("datumafgerond")}`;
              break;
            default:
              break;
          }
        }
      );
    },
    onGenerateButtonClicked() {
      this.generatingReport = true;
      this.reportID = "";
      this.downloadUrl = "";
      const isCustomInput =
        get(this.selectedOptions, "period.Id", FixedPeriodType.ThisYear) ===
        FixedPeriodType.FreePeriod;

      let settings = {
        ReportType: this.selectedOptions.reportTypeValue.Id,
        Language: this.locale === "en" ? Language.English : Language.Nederlands,
        ReportTijdSelectieType: this.selectedOptions.reportTijdSelectieTypeValue.Id,
        FromDate: isCustomInput
          ? (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString()
          : this.selectedOptions.periodFromDate.toISOString(),
        ToDate: isCustomInput
          ? (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString()
          : this.selectedOptions.periodToDate.toISOString(),	
        LeadTypen: get(
          this.selectedOptions as Object,
          "leadTypesValue",
          []
        ).map((elem: any) => Number(elem["Id"])),

        Vestigingen: get(this.selectedOptions as Object, "vestigingenValue", []).map(
          (elem: any) => String(elem["Id"])
        ),
        Modellen: get(this.selectedOptions as Object, "modellenValue", []).map(
          (elem: any) => String(elem["Id"])
        )
      } as ReportQueryViewModel;

      axios
        .post("/api/backend/v1/reports/generate", settings, {
          headers: { "Content-Type": "application/json" }
        })
        .then(response => {
          if (!!response && !!response.data && !!response.data.ReportID) {
            this.reportID = response.data.ReportID;
          }
        })
        .catch(error => {});
    },
    startdownload() {
      axios
        .get(this.downloadUrl, { responseType: "blob" })
        .then(response => {
          let filename = "";
          let disposition = get(
            response.headers,
            "content-disposition",
            get(response.headers, "Content-Disposition", "")
          );
          if (!!disposition && disposition.indexOf("attachment") !== -1) {
            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            let matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          // Let the user save the file.
          saveAs(response.data, filename);
        })
        .catch(response => {
          console.error(
            "Could not Download the Excel report from the backend.",
            response
          );
        });
    },
    onReportGenerated(userid: string, reportid: string) {
      if (
        this.$store.getters.userId === userid &&
        !!this.reportID &&
        reportid === this.reportID
      ) {

        this.generatingReport = false;
        this.downloadUrl = "/api/backend/v1/reports/download/" + reportid;
        this.startdownload();
      }
    },
    connect() {
      if (!this.destroyed && "WebSocket" in window) {
        let that = this;
        let protocol = location.protocol === "https:" ? "wss://" : "ws://";

        this.websocket = new WebSocket(
          protocol + location.host + "/api/backend/v1/reports/live"
        );

        this.websocket.onopen = () => {
          this.waitConnect = 2500;
          //console.log("websocked opened!");
          if (!this.timerRenewToken) {
            this.timerRenewToken = setInterval(this.renewToken, 30 * 60 * 1000);
          }
        };

        this.websocket.onmessage = evt => {
          const received_msg = evt.data;
          //console.log(Math.floor(Date.now()) + "  " + received_msg);

          try {
            let obj = JSON.parse(evt.data);
            this.onReportGenerated(obj.UserId, obj.ReportId);
          } catch (err) {}
        };

        this.websocket.onclose = () => {
          // console.log("websocked closed");
          if (!this.destroyed) {
            // Reconnect will be attempted after a while
            setTimeout(() => {
              if (this.waitConnect > 1000 * 6) {
                this.$router.push({ name: "logout" });
              } else {
                that.connect();
                this.waitConnect += 500;
              }
            }, this.waitConnect);
          }
        };
      }
    },
    renewToken() {
      this.$store.dispatch<Dispatcher<ApplicationActions>>({
        type: "renewTokenIfOutdated"
      });
    }
  },
  beforeDestroy() {
    this.destroyed = true;
    if (!!this.websocket) {
        this.websocket.onopen = null;
        this.websocket.onmessage = null;
        this.websocket.onclose = null;
        this.websocket.onerror = null;

        this.websocket.close();
        this.websocket = null;
    }
    if (!!this.timerRenewToken) {
      clearInterval(this.timerRenewToken);
    }
  }
});
